import { Input } from '@/components/ui/input'
import { SettingsRow } from '@/components/settings/settings-row'
import { SettingsImageUploadRow } from '@/components/settings/settings-image-upload-row'
import { OrganisationLogoUploadField } from '@/components/account/organisation-logo-upload-field'
import { ORGANISATION_LOGO_HELPER_TEXT } from '@/lib/organisation-logo-media'

export type OrganisationIdentityFieldsValue = {
  name: string
  slug: string
}

type OrganisationIdentityFieldsProps = {
  layout: 'settings'
  value: OrganisationIdentityFieldsValue
  onChange: (patch: Partial<OrganisationIdentityFieldsValue>) => void
  logoUrl?: string | null
  logoFieldKey?: string
  uploadLogo?: (file: File) => Promise<unknown>
  deleteLogo?: () => Promise<unknown>
  isUploadingLogo?: boolean
  isDeletingLogo?: boolean
  disabled?: boolean
}

/** Organisation-owned identity fields (logo, name, slug) for settings-class surfaces. */
export function OrganisationIdentityFields({
  layout,
  value,
  onChange,
  logoUrl,
  logoFieldKey,
  uploadLogo,
  deleteLogo,
  isUploadingLogo,
  isDeletingLogo,
  disabled,
}: OrganisationIdentityFieldsProps) {
  if (layout !== 'settings') {
    return null
  }

  return (
    <>
      <SettingsImageUploadRow label="Logo" description={ORGANISATION_LOGO_HELPER_TEXT}>
        <OrganisationLogoUploadField
          logoUrl={logoUrl}
          logoFieldKey={logoFieldKey}
          uploadLogo={uploadLogo}
          deleteLogo={deleteLogo}
          isUploadingLogo={isUploadingLogo}
          isDeletingLogo={isDeletingLogo}
          disabled={disabled}
          persistenceNote={null}
        />
      </SettingsImageUploadRow>
      <SettingsRow label="Organisation name">
        <Input
          id="org-settings-name"
          aria-label="Organisation name"
          value={value.name}
          onChange={(event) => onChange({ name: event.target.value })}
          className="h-8 w-full text-sm sm:max-w-[320px]"
          placeholder="Organisation name"
          disabled={disabled}
        />
      </SettingsRow>
      <SettingsRow
        label="Slug"
        description="Used in URLs for this organisation."
        showDivider={false}
      >
        <Input
          id="org-settings-slug"
          aria-label="Organisation slug"
          value={value.slug}
          onChange={(event) => onChange({ slug: event.target.value })}
          className="h-8 w-full text-sm sm:max-w-[320px]"
          placeholder="organisation-slug"
          disabled={disabled}
        />
      </SettingsRow>
    </>
  )
}
